var CoordinateNote = require('./base'),
    StrikeThroughShapeModel = require('../../../../../../canvas/models/coordinate/strikeThrough'),
    ShrikeThroughShapeView = require('../../../../../../canvas/views/shape/strikeThrough');

module.exports = CoordinateNote.extend({

    init: 'L',
    desc: 'Strikethrough',
    createHotKey: 'k',
    actionTitle: 'Strikethrough',
    iconClass: 'icon-strike',

    defaultShapeColor: '#000000',
    defaultFillOpacity: 1, // ( when not editing, these should be opaque )

    ShapeModel: StrikeThroughShapeModel,

    shapeView: function(options) {
        return new ShrikeThroughShapeView(options);
    },

    /*
    *  With this design may want different attributes for different states:
    *  - creation prior to shrink
    *  - post shrink
    *  - resizing shrunken rectangle
    *  - waiting to see what people think
    * fill-opacity:
    *  - rect and highlight are 0.25 -- if left 0.25 and box is small, (and left stroke),
    *  - the stroke will be the color the user see's and not see through anyway.
    *  - want see through to some extent: user can see what doing and to denote the active note
    *  - on the other hand want as dark as possible so it will look like the product ( less confusion )
    * stroke-width:
    * - still want a way to differentiate the active shape from others (like with rects and highlights) ...
    * - Could leave it and make fill transparent but the problem is ihis makes the lines look like rectangles,
    * - which the aren't.
    * - an issue is not being able to depict the 'active' note like with the other coordinate shapes without a stroke,
    * - but I think the trade-off is worse
    * could give a stroke with a different color but then the 'line' looks like the other color -- too confusing
    * */
    defaultSVGAttrsEdit: function() {

        var baseAttrs = CoordinateNote.prototype.defaultSVGAttrsEdit.apply( this, arguments );

        return _.extend( {}, baseAttrs, {
            'fill-opacity': 0.7 ,
            'stroke-width': 0
        });

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/drawable/coordinate/strikeThrough.js
 ** module id = 308
 ** module chunks = 0
 **/